import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/analytics/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Navigate to="/analytics/usage-and-cost" />
}
